import React, { useReducer } from 'react';
import axios from 'axios';
import CustomerAuthContext from './customerAuthContext';

const initialState = {
  customer: null,
  token: localStorage.getItem('customer_token') || null,
  loading: false,
  error: null
};

function reducer(state, action) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return { ...state, token: action.payload.token, customer: action.payload.customer, loading: false, error: null };
    case 'LOAD_CUSTOMER':
      return { ...state, customer: action.payload, loading: false };
    case 'LOGOUT':
      return { ...state, token: null, customer: null, loading: false };
    case 'ERROR':
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
}

const CustomerAuthState = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  // 1. Adım: e-postaya tek kullanımlık kod (OTP) gönder
  const requestOtp = async (email) => {
    try {
      const res = await axios.post('/api/customers/login/request-otp', { email });
      return res.data;
    } catch (err) {
      dispatch({ type: 'ERROR', payload: err.response?.data?.msg || err.message });
      throw err;
    }
  };

  // 2. Adım: kodu doğrula ve giriş yap
  const login = async (email, code, full_name, phone_number) => {
    try {
      const res = await axios.post('/api/customers/login', { email, code, full_name, phone_number });
      if (res.data.token) localStorage.setItem('customer_token', res.data.token);
      dispatch({ type: 'LOGIN_SUCCESS', payload: { token: res.data.token, customer: res.data.customer } });
      return res.data;
    } catch (err) {
      dispatch({ type: 'ERROR', payload: err.response?.data?.msg || err.message });
      throw err;
    }
  };

  const googleLogin = async (token) => {
    try {
      const res = await axios.post('/api/customers/google', { token });
      if (res.data.token) localStorage.setItem('customer_token', res.data.token);
      dispatch({ type: 'LOGIN_SUCCESS', payload: { token: res.data.token, customer: res.data.customer } });
      return res.data;
    } catch (err) {
      dispatch({ type: 'ERROR', payload: err.response?.data?.msg || err.message });
      throw err;
    }
  };

  const loadCustomer = async () => {
    const token = state.token || localStorage.getItem('customer_token');
    if (!token) return null;
    try {
      const res = await axios.get('/api/customers/auth', { headers: { Authorization: `Bearer ${token}` } });
      dispatch({ type: 'LOAD_CUSTOMER', payload: res.data });
      return res.data;
    } catch (err) {
      dispatch({ type: 'ERROR', payload: err.response?.data?.msg || err.message });
      return null;
    }
  };

  const logout = () => {
    localStorage.removeItem('customer_token');
    dispatch({ type: 'LOGOUT' });
  };

  const getAuthHeaders = () => {
    const token = state.token || localStorage.getItem('customer_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  return (
    <CustomerAuthContext.Provider value={{
      customer: state.customer,
      token: state.token,
      loading: state.loading,
      error: state.error,
      requestOtp,
      login,
      googleLogin,
      loadCustomer,
      logout,
      getAuthHeaders
    }}>
      {children}
    </CustomerAuthContext.Provider>
  );
};

export default CustomerAuthState;
